"use client";
import { useState } from "react";
import { ProductDescriptionSetting, ProductJson } from "@/types/Product.type";
import Collapse from "@/components/ui/Collapse";
import LinkElement from "@/components/LinkElement";
import ProductDescriptionsTags from "./ProductDescriptionsTags";
import { cn, parserHtml } from "@/utils/utils";
import { ChevronDownIcon } from "@/components/icons";
type Props = {
	product: ProductJson;
	descriptions: ProductDescriptionSetting[];
	sku: string;
	className?: string;
};

const ProductDescriptionsMobile = ({
	product,
	descriptions,
	sku,
	className,
}: Props) => {
	const [viewMore, setViewMore] = useState(false);
	const tabs = [
		{
			header: "Chi tiết sản phẩm",
			body: (
				<>
					<div className="text-base">
						<ul>
							<li className=" flex  mb-[10px] ">
								<p className="  min-w-[160px] font-bold   text-gray-400 text-base">
									Mã hàng{" "}
								</p>
								<p className=" text-base text-gray-500">{sku}</p>
							</li>

							<li className=" flex  mb-[10px]">
								<p className="  min-w-[160px] font-bold   text-gray-400 text-base">
									{" "}
									Thương hiệu
								</p>
								<p className=" text-base text-gray-500">
									{product.brand && (
										<LinkElement
											href={`/blogs/thuong-hieu-nuoc-hoa/${product.brand.handle}`}
											className=" text-blue-500">
											{" "}
											{product.brand.title}
										</LinkElement>
									)}{" "}
								</p>
							</li>

							<li className=" flex items-center mb-[10px]">
								<p className="  min-w-[160px] font-bold   text-gray-400 text-base">
									{" "}
									Xuất xứ{" "}
								</p>
								<p className=" text-gray-500 text-base">{product.origin}</p>
							</li>

							<li className=" flex items-center mb-[10px]">
								<p className="  min-w-[160px] font-bold   text-gray-400 text-base">
									{" "}
									Năm phát hành{" "}
								</p>
								{product.production_year > 0 && (
									<p className=" text-gray-500 text-base">
										{product.production_year}
									</p>
								)}
								{/* <ProductTags tags={product.tags} type="YEAR_OF_RELEASE" /> */}
							</li>
							<ProductDescriptionsTags tags={product.tags} />
						</ul>
					</div>
					<div className="">
						<div
							className={` ${!viewMore ? "des_product_detail" : ""}   text-base 
							transition-all`}
							dangerouslySetInnerHTML={{ __html: product.description }}></div>
						<div
							onClick={() => {
								setViewMore((prev) => !prev);
							}}
							className={cn(
								` md:hidden view_more_des ${viewMore ? "" : "view_more_shadow"}`
							)}>
							{viewMore ? (
								<>
									Rút gọn{" "}
									<ChevronDownIcon className="w-4 h-4 rotate-180 translate-y-[1px]" />
								</>
							) : (
								<>
									Xem thêm{" "}
									<ChevronDownIcon className="w-4 h-4 translate-y-[1px]" />
								</>
							)}
						</div>
					</div>
				</>
			),
		},
		...descriptions.map((dec) => ({
			header: dec.title,
			body: (
				<div
					className="text-base"
					dangerouslySetInnerHTML={{ __html: parserHtml(dec.content) }}></div>
			),
		})),
	];
	return (
		<Collapse
			classNameBody="px-4"
			defaultActiveKeys={[0]}
			type="multiple"
			className={className}
			items={tabs.map((tab, index) => {
				return {
					...tab,
					key: index,
				};
			})}
		/>
	);
};

export default ProductDescriptionsMobile;
